(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["herbella-info"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const setup = (root) => {
      if (root.dataset.hbReady) return;
      root.dataset.hbReady = 'true';

      // Apariție la scroll
      const items = root.querySelectorAll('.hb-reveal');
      if ('IntersectionObserver' in window && !reduceMotion.matches) {
        root.classList.add('hb-js');
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          });
        }, { rootMargin: '0px 0px -40px 0px' });
        items.forEach((item) => io.observe(item));
      }

      // Acordeon animat: un singur răspuns deschis odată
      const all = [...root.querySelectorAll('[data-hb-accordion] details')];

      const close = (details) => {
        if (!details.open) return;
        details.classList.remove('is-open');
        const panel = details.querySelector('.hb-info__a');
        const done = () => { if (!details.classList.contains('is-open')) details.open = false; };
        if (reduceMotion.matches) return done();
        panel.addEventListener('transitionend', done, { once: true });
        setTimeout(done, 500);
      };

      const open = (details) => {
        all.forEach((other) => other !== details && close(other));
        details.open = true;
        requestAnimationFrame(() => requestAnimationFrame(() => details.classList.add('is-open')));
      };

      all.forEach((details) => {
        if (details.open) details.classList.add('is-open');
        details.querySelector('summary').addEventListener('click', (event) => {
          event.preventDefault();
          details.classList.contains('is-open') ? close(details) : open(details);
        });
      });
    };

    const init = () => document.querySelectorAll('.hb-info').forEach(setup);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
